<img
  *ngIf="file.type !== AcceptEnum.PDF; else pdfIcon"
  class="preview"
  [src]="src$ | async"
  [alt]="'Prévisualisation de ' + label"
/>

<ng-template #pdfIcon>
  <div class="pdf-icon">
    <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.0623 18.6372C34.5911 19.164 34.5927 20.0196 34.0659 20.5483L23.2961 31.3591C23.0426 31.6136 22.6981 31.7567 22.3389 31.7568C21.9797 31.7568 21.6352 31.6138 21.3816 31.3594L15.9353 25.8952C15.4084 25.3666 15.4098 24.511 15.9384 23.9841C16.467 23.4573 17.3226 23.4587 17.8495 23.9873L22.3385 28.4909L32.1512 18.6409C32.678 18.1121 33.5336 18.1105 34.0623 18.6372Z"
        fill="#5770be"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.1101 49.9998C13.6871 50.0492 3.68343 42.3494 0.807579 31.2942C-2.06827 20.239 2.91523 8.64056 12.9144 3.11733C22.9135 -2.4059 35.3846 -0.448915 43.2113 7.87158C51.0381 16.1921 52.2295 28.7595 46.1056 38.4024C45.4926 39.3706 44.2108 39.6586 43.2426 39.0456C42.2744 38.4326 41.9864 37.1508 42.5994 36.1826C48.2603 27.1854 46.205 15.3651 37.8394 8.80681C29.4737 2.24854 17.5046 3.07427 10.1188 10.7192C2.73298 18.3641 2.32035 30.3547 9.16311 38.4893C16.0059 46.6239 27.89 48.2705 36.6867 42.3028C37.3019 41.8877 38.0918 41.8324 38.7589 42.1576C39.4259 42.4829 39.8688 43.1393 39.9207 43.8796C39.9725 44.6199 39.6255 45.3316 39.0103 45.7467C34.9032 48.5156 30.0634 49.9965 25.1101 49.9998Z"
        fill="#D1E1F5"
      />
    </svg>

    <span class="pdf-icon__text">Document envoyé</span>
  </div>
</ng-template>

<span class="actions" [class.actions--expanded]="confirmation" [class.actions--hover]="mouseover || confirmation">
  <span *ngIf="confirmation" class="confirmation" @expand>
    Êtes-vous sûr(e)&nbsp;?

    <button
      class="cta cta--confirmation"
      type="button"
      mat-button
      color="primary"
      (click)="confirmation = false"
      aria-label="Annuler la suppression le logo"
    >
      Annuler
    </button>

    <span class="divider" aria-hidden="true"></span>

    <button
      class="cta cta--confirmation"
      type="button"
      mat-button
      color="primary"
      (click)="delete.emit()"
      aria-label="Supprimer le logo"
    >
      Supprimer
    </button>
  </span>

  <button
    class="cta cta--delete"
    type="button"
    mat-icon-button
    color="primary"
    (click)="confirmation = true"
    [disabled]="confirmation"
    aria-label="Delete the company logo"
  >
    <mat-icon svgIcon="cross" role="presentation" width="26" height="26"></mat-icon>
  </button>
</span>
